import * as React from 'react';
import Select from './Select';

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
const countryList = countries.getNames('en') as { [key: string]: string };
const countryDetailsList: CountryDetails[] = Object.keys(countryList).map(k => { return { iso2Code: k, countryName: countryList[k] }; });

export interface CountryDetails {
  iso2Code: string;
  countryName: string;
}

export interface Props {
  id?: string;
  label?: string;
  iso2Code?: string;

  divClasses?: string;

  // Adding a property to add external css class.
  countryDivClassName?: string;
  countrySelectClassName?: string;
  countryLabelClassName?: string;
  selectClassName?: string;

  dataInvalidMessage?: string;
  forceHighlightErrors?: boolean;
  validator?: (s: string) => boolean;
  onChange(countryDetails: CountryDetails): void;
}

interface State {
  wasChanged: boolean;
}

class CountrySelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { wasChanged: false };
  }

  renderCountryOption(countryDetails: CountryDetails, index: number) {
    return (
      <option
        key={countryDetails.iso2Code}
        data-key={countryDetails.iso2Code}
        value={countryDetails.countryName}
        selected={countryDetails.iso2Code === this.props.iso2Code}
      >
        {countryDetails.countryName}
      </option>
    );
  }

  renderCountryOptions() {
    return countryDetailsList
      .sort(country => {
        return country.countryName.localeCompare(country.countryName);
      })
      .map((c, i) => {
        return this.renderCountryOption(c, i);
      });
  }

  selectionChanged = (countryName: string) => {
    const countryDetails = countryDetailsList
      .find(details => details.countryName === countryName);

    const iso2Code = countryDetails ? countryDetails.iso2Code : '';

    this.props.onChange({ iso2Code: iso2Code, countryName: countryName });
  }

  render() {
    const value = this.props.iso2Code ? this.props.iso2Code : '';

    let valid: boolean = true;

    if ((this.state.wasChanged || this.props.forceHighlightErrors) && this.props.validator && this.props.validator(value) === false) {
      valid = false;
    }

    // Check if external css properties comes from parent
    let countryDivUserClass = this.props.countryDivClassName === null ? '' : this.props.countryDivClassName;
    let countrySelectUserClass = this.props.countrySelectClassName === null ? '' : this.props.countrySelectClassName;
    let countryLabelUserClass = this.props.countryLabelClassName === null ? '' : this.props.countryLabelClassName;

    const selectedValue = countryDetailsList.find(c => c.iso2Code === value) || { countryName: 'Country' };

    return (
      <div className={`input-field ${this.props.divClasses} ${countryDivUserClass}`} id={`${this.props.id}-input-field`}>
        <Select
          selectClassName={this.props.selectClassName}
          value={selectedValue.countryName}
          onChange={this.selectionChanged}
          css={`validate ${valid || 'invalid'} ${countrySelectUserClass}`}
        >

          <option value="" disabled={true}>
            Country
          </option>

          {this.renderCountryOptions()}

        </Select>

        <label className={countryLabelUserClass} data-error={this.props.dataInvalidMessage}>{this.props.label || 'Country'}</label>
      </div>
    );
  }
}

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/Components/CountrySelect.tsx